/**
 * Default page size for orders table pagination
 */
export const DEFAULT_PAGE_SIZE = 25;

/**
 * Debounce time in milliseconds for search input changes
 */
export const DEBOUNCE_TIME = 300;

/**
 * URL query parameter keys
 */
export const URL_PARAMS = {
  SEARCH: 'search',
  SUPPLIER_REF_ID: 'supplierRefId',
  PAGE_SIZE: 'size',
  CURSOR_AFTER: 'after',
  CURSOR_BEFORE: 'before',
} as const;
